import { Children, ReactNode } from 'react';
import useStyles from './styles';

type GridListProps = {
  children: ReactNode;
};

function GridList({ children }: GridListProps) {
  const styles = useStyles();
  return (
    <div className={styles.root}>
      {Children.map(children, child => (
        <div className={styles.column}>{child}</div>
      ))}
    </div>
  );
}

export default GridList;
